export interface Template<T> {
  id: string | number;
  title?: string;
  group: string;
  timestamp: string;
  value: Partial<T>
}
